<template>
  <div>
    <GmapMap
      ref="gmap"
      class="google-map"
      :center="mapCenter"
      :zoom="8"
      :options="mapOptions"
      :style="`width: 100%; height: ${height}`"
      @click="infoWindowOpened = false"
    >
      <!-- @tilesloaded="onMapLoaded" -->
      <!-- start marker -->
      <gmap-custom-marker :marker="points[0]">
        <div>
          <v-icon large>
            mdi-map-marker
          </v-icon>
        </div>
      </gmap-custom-marker>
      <!-- start marker -->
      <!-- End  marker -->
      <gmap-custom-marker :marker="Marker">
        <div class="pin-icon-container">
          <div
            class="pin-circle"
            :class="vehicleStatus"
          >
            <Icons :name="`marker-${vehicleBodyType}`" />
          </div>
          <div class="pin-arrow" />
        </div>
      </gmap-custom-marker>
      <!-- End  marker -->

      <!-- Parkerd -->
      <template>
        <gmap-custom-marker
          v-for="(evtMkr, i) in events.parked"
          :key="`${i}-eventParked`"
          :marker="{ lat: evtMkr?.points[0], lng: evtMkr?.points[1] }"
        >
          <div @click="showInfo(evtMkr)">
            <Icons :name="`marker-parked`" />
          </div>
        </gmap-custom-marker>
      </template>
      <!-- Idle -->
      <template>
        <gmap-custom-marker
          v-for="(evtMkr, i) in events.idle"
          :key="`${i}-eventParked`"
          :marker="{ lat: evtMkr?.points[0], lng: evtMkr?.points[1] }"
        >
          <div @click="showInfo(evtMkr)">
            <Icons :name="`marker-idle`" />
          </div>
        </gmap-custom-marker>
      </template>

      <!-- Info Window -->
      <GmapInfoWindow
        :position="infoWindowPosition"
        :opened="infoWindowOpened"
        @closeclick="infoWindowOpened = false"
      >
        <div class="info-window">
          <div class="popup-box">
            <div class="title">
              {{ infoWindowContent.state }}
            </div>
            <div class="">
              Latitude:
              <span>{{ infoWindowContent?.latitude?.toFixed(4) }}</span>
            </div>
            <div class="">
              Longitude:
              <span>{{ infoWindowContent?.longitude?.toFixed(4) }}</span>
            </div>
            <div class="">
              Start Time:
              <span>{{ infoWindowContent?.start_time }}</span>
            </div>
            <div class="">
              End Time:
              <span>{{ infoWindowContent?.end_time }}</span>
            </div>
            <div class="">
              Duration:
              <span>{{ infoWindowContent?.formatted_duration }}</span>
            </div>
          </div>
        </div>
      </GmapInfoWindow>

      <!-- polyline -->
      <GmapPolyline
        :path="points"
        :options="polylineOptions"
      />
      <!-- polyline -->
    </GmapMap>
  </div>
</template>
<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";
export default {
  components: {
    GmapCustomMarker,
    Icons: () => import("@/components/base/icons.vue"),
  },
  props: {
    points: {
      type: Array,
      default: () => [],
    },
    vehicleStatus: {
      type: String,
      default: "active",
    },
    vehicleBodyType: {
      type: String,
      default: "bike",
    },
    height: {
      type: String,
      default: "380px",
    },
    events: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      mapCenter: { lat: 30.3753, lng: 69.3451 },
      mapOptions: {
        fullscreenControl: true,
        fullscreenControlOptions: {
          position: window.google?.maps.ControlPosition.RIGHT_BOTTOM,
        },
      },
      polylineOptions: {
        strokeColor: "#20a390",
        strokeOpacity: 1.0,
        strokeWeight: 4,
      },
      infoWindowOpened: false,
      infoWindowPosition: null,
      infoWindowContent: "",
    };
  },
  computed: {
    Marker() {
      const ln = this.points.length;
      return this.points[ln - 1] || { lat: 30.3753, lng: 69.3451 };
    },
  },
  mounted() {
    this.onMapLoaded();
  },
  methods: {
    onMapLoaded() {
      this.$refs.gmap.$mapPromise.then(() => {
        if (window.google && window.google.maps) {
          this.mapOptions.fullscreenControlOptions = {
            position: window.google.maps.ControlPosition.BOTTOM_RIGHT,
          };
        }
        this.setMapBounds();
      });
    },
    setMapBounds() {
      if (!this.points.length) return;
      const bounds = new window.google.maps.LatLngBounds();
      this.points.forEach((coord) => {
        bounds.extend(new window.google.maps.LatLng(coord.lat, coord.lng));
      });
      this.$refs.gmap.$mapObject.fitBounds(bounds);
    },
    showInfo(v) {
      this.infoWindowPosition = {
        lat: parseFloat(v.latitude),
        lng: parseFloat(v.longitude),
      };
      this.infoWindowContent = v;
      this.infoWindowOpened = true;
    },
  },
};
</script>
<style scoped>
.pin-icon-container {
  position: relative;
  width: 40px;
  height: 60px;
}
.pin-circle {
  width: 40px;
  height: 40px;
  padding: 5px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
.pin-arrow {
  position: absolute;
  top: 40px;
  left: 15px;
  width: 10px;
  height: 20px;
  background-color: #ffffff;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}
:deep .active svg path {
  fill: #23bdaa !important;
}
:deep .in_active svg path,
:deep .inactive svg path {
  fill: #ffae20 !important;
}
:deep .offline svg path {
  fill: #fa896b;
}

.info-window .title {
  text-transform: uppercase !important;
  font-size: 16px !important;
  font-weight: 600;
}
</style>
